import type { CartAddressData, CartAddresses } from 'services/types';
import type { LocaleIso } from 'utils';
import { hasAddressData } from '../../../utils/hasAddressData';
import { isAddressUsableForLocale } from '../../../utils/isAddressUsableForLocale';

/** Resolves the valid shipping-related address to compare with the billing address (shipping before Packstation). */
export function resolveShippingAddressForBillingComparison(
  addresses: CartAddresses['addresses'] | undefined,
  locale: LocaleIso
): CartAddressData | undefined {
  return [addresses?.shipping, addresses?.packetstation].find(
    address => hasAddressData(address) && isAddressUsableForLocale(address, locale)
  );
}
